import { render, staticRenderFns } from "./BmOrderDetail.vue?vue&type=template&id=5b9c9d88&"
import script from "./BmOrderDetail.vue?vue&type=script&lang=js&"
export * from "./BmOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports